import { derived, writable } from 'svelte/store';
import { CharityDashboardService } from '../lib/api/charityServices';

export interface CharityPendingConfirmationState {
  count: number;
  valueCents: number;
  loading: boolean;
  loaded: boolean;
}

const initialState: CharityPendingConfirmationState = {
  count: 0,
  valueCents: 0,
  loading: false,
  loaded: false,
};

export const charityPendingConfirmation = writable<CharityPendingConfirmationState>(initialState);

export const hasCharityPendingConfirmation = derived(
  charityPendingConfirmation,
  ($state) => $state.count > 0 || $state.valueCents > 0
);

export function setCharityPendingConfirmation(
  count: number,
  valueCents: number
): void {
  charityPendingConfirmation.set({
    count,
    valueCents,
    loading: false,
    loaded: true,
  });
}

export async function refreshCharityPendingConfirmation(): Promise<void> {
  charityPendingConfirmation.update((state) => ({ ...state, loading: true }));

  try {
    const result = await CharityDashboardService.getDashboardStats();
    if (result.success && result.stats) {
      setCharityPendingConfirmation(
        result.stats.pendingConfirmationCount ?? 0,
        result.stats.pendingConfirmationValueCents ?? 0
      );
      return;
    }
  } catch (error) {
    console.error('Failed to load charity pending confirmation stats:', error);
  }

  charityPendingConfirmation.update((state) => ({
    ...state,
    loading: false,
    loaded: true,
  }));
}

export function clearCharityPendingConfirmation(): void {
  charityPendingConfirmation.set(initialState);
}
